import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';



export const INITIAL_STATE = Immutable({
    selectedCountry: 0,
    selectedState: 0,
    selectedCity: 0,
    selectedPartner: 0,
    selectedSpeciality: 0,
    additionalRequest: '',

    isPosting: false,
    status: false,
    error: ''
});



const dropdownSelect = (state, action) => {
    const newState = {};

    switch(action.id) {
        case 'country': {
            newState.selectedCountry = action.index;
            break;
        }

        case 'state': {
            newState.selectedState = action.index;
            break;
        }
        
        case 'city': {
            newState.selectedCity = action.index;
            break;
        }
        
        case 'partner': {
            newState.selectedPartner = action.index;
            break;
        }
        
        case 'speciality': {
            newState.selectedSpeciality = action.index;
            break;
        }
    }

    return state.merge(newState);
};


const changeRequest = (state, action) => {
    return state.merge({
        additionalRequest: action.request
    });
};


const resetState = (state, action) => {
    return state.merge({
        isPosting: false,
        status: false,
        error: ''
    });
};


const postAppointmentRequest = (state, action) => {
    return state.merge({
        isPosting: true,
        status: false,
        error: ''
    });
};


const responseAppointmentRequest = (state, action) => {
    if(action.response.status) {
        return state.merge({
            isPosting: false,
            status: true,
        });
    }

    else {
        return state.merge({
            isPosting: false,
            status: false,
            error: action.response.error
        });
    }
};



const ACTION_HANDLERS = {
    [Types.RESET_APPOINTMENT_REQUEST]: resetState,
    [Types.DRA_DROPDOWN_SELECT]: dropdownSelect,
    [Types.DRA_CHANGE_REQUEST]: changeRequest,
    [Types.POST_APPOINTMENT_REQUEST]: postAppointmentRequest,
    [Types.RESPONSE_APPOINTMENT_REQUEST]: responseAppointmentRequest
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)